export const stop = {
  name: "stop" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 3.818a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5.05 0a.91.91 0 0 1 .91-.91h8.08a.91.91 0 1 1 0 1.82H7.96a.91.91 0 0 1-.91-.91Z" clip-rule="evenodd"/></svg>`,
  keywords: ["stop"],
  category: "other" as const,
};
